import React, { useState, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import axios from 'axios';

import { getToken, APIBase } from '../../services/API';

import styled, { css } from 'styled-components';
import { HorizontalStack, SmartContainer, Stack, StyledGrid, StyledGridItem, StyledImagePlaceholder, Surface } from '../../styles/Containers';
import { StyledB, StyledEllipsis, StyledImg, StyledHr, StyledP } from '../../styles/StyledHTML';
import { jsRespondTo, respondTo, setSpace, Theme } from '../../styles/Theme';

import { StyledCircularProgressWithLabel, StyledCircularProgress, StyledLinearProgressWithLabel } from '../../styles/matieralui/Progress';
import { StyledIconButton } from '../../styles/matieralui/IconButton';
import { IconAdd, IconUpload, IconUploadCloud, IconError } from '../../capturecollab/Icons';
import { StyledButton } from '../../styles/matieralui/Button';
import { AssetCard } from '../../capturecollab/modules/Assets/AssetCard';
import { ImageCroppingPresets } from './MediaUtils';
import { Divider } from '@mui/material';
const getColor = (props) => {
    if (props.isDragAccept) {
        return 'green';
    }
    if (props.isDragReject) {
        return 'red';
    }
    if (props.isDragActive) {
        return 'purple';
    }
    return `${Theme.colors.base}`;
}

const StyledUploadText = styled(Stack)`
    .icon{display:block;}
    .mobileButton { display: none; }
  
    ${respondTo('mobile', css`
    .icon{display:none;}
    .mobileButton { display: block; }
    `)}
`

const StyledDropTarget = styled(SmartContainer)`
    width:100%;
    height: 400px;
`

export const useFileUploader = ({ callback, network = false, isAsset = false }) => {

    const [uploading, setUploading] = useState(false);
    const [files, setFiles] = useState([]);
    const [uploaded, setUploaded] = useState([]);
    const [uploadErrorFiles, setUploadErrorFiles] = useState([]);
    const [errorMessage, setErrorMessage] = useState();
    const [progress, setProgress] = useState([]);

    const runUpload = async (file) => {
        const token = getToken();
        const config = {
            onUploadProgress: function (progressEvent) {
                var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                const progress = files.map(item => {
                    if (file.path === item.path) item.progress = percentCompleted;
                    return item;
                })

                // Set Progress
                setProgress(progress);

            },
            headers: {
                Authorization: 'Bearer ' + token,
                // 'Access-Control-Allow-Origin': "true",
                "Content-Type": "multipart/form-data",
                'Accept': 'application/json',
            }

        }
        const formData = new FormData();
        formData.append("file", file);
        let path = (network) ? `${APIBase}/v1/network/upload` : `${APIBase}/v1/upload`;
        if (isAsset !== false) {
            path += '?asset=true';
        }

        try {
            const res = await axios.post(path, formData, config)
            return res;
        } catch (error) {
            return { data: { status: "error", error: error, message: error.message } }
        }

    }

    const uploadFile = async (file) => {

        // TODO: Replace with Axios
        const res = await runUpload(file);


        // Update State
        if (res.data.status === 'success') {

            const newFiles = files.filter(item => {
                if (file.path !== item.path) return item;
                else {

                    if (callback) callback(res.data.data);

                    item.data = res.data.data;

                    setUploaded([...uploaded, item]);
                    return false;
                }
            })
            setFiles(newFiles);
        } else if (res.data.status === 'error') {

            const newFiles = files.filter(item => {
                if (file.path !== item.path) return item;
                else {
                    const newItem = { ...item };
                    newItem.errorMessage = res.data.message;

                    newItem.type = item.type;
                    setUploadErrorFiles([...uploadErrorFiles, newItem]);
                    return false;
                }
            })
            setFiles(newFiles);

        }

    }

    // Run on files change
    useEffect(() => {
        if (files && files.length > 0) {
            setUploading(true);
            uploadFile(files[0])
            setProgress(files);
        } else if (progress && progress.length > 0 && files.length <= 0) {
            setProgress([]);
            setUploading(false);
        } else {
            setUploading(false);
        }
    }, [files])

    return {
        uploading,
        setFiles,
        progress,
        uploaded,
        uploadErrorFiles,
        setUploadErrorFiles,
        errorMessage,
        files
    }

}

export const MediaUpload = ({ accept, maxFiles, maxSize, network = false, isAsset = false, onSuccessfulUpload, onCompleteUpload }) => {

    const isMobile = jsRespondTo('mobile');

    const [totalFiles, setTotalFiles] = useState(0);
    const onUploadItemSuccess = (model) => {
        if (onSuccessfulUpload) onSuccessfulUpload(model);


    }


    // File Uploader
    const { uploading, setFiles, files, progress, uploaded, uploadErrorFiles, setUploadErrorFiles } = useFileUploader({ callback: onUploadItemSuccess, network, isAsset });

    const onFullUploadFinished = () => {
        if (onCompleteUpload) onCompleteUpload({ files, progress, uploaded, uploadErrorFiles });
    }

    // Dropzone Config
    const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
        accept, maxFiles, maxSize, onDrop: acceptedFiles => {
            setTotalFiles(totalFiles + acceptedFiles.length);
            setFiles(acceptedFiles.map(file => Object.assign(file, {
                preview: URL.createObjectURL(file),
                progress: 0
            })));
        }
    });

    useEffect(() => {
        const totalAttempts = uploaded.length + uploadErrorFiles.length;
        if (totalAttempts <= 0) return;

        if (uploaded.length >= totalFiles) {

            onFullUploadFinished();
        }

        if (totalAttempts >= totalFiles) {

            onFullUploadFinished();
        }
    }, [uploaded, files, uploadErrorFiles])


    const renderPreviews = () => {
        if (!progress || progress.length <= 0) return (<div></div>)
        return progress.map(file => (
            <StyledGridItem>
                <MediaUploadPreview key={file.path} file={file} loading={uploading} />
            </StyledGridItem>
        ))
    }

    const renderUploaded = () => {
        if (!uploaded || uploaded.length <= 0) return (<div></div>);
        return uploaded.map(file => (
            <StyledGridItem>
                <MediaUploadPreview key={file.path} file={file} />
                {/* <AssetCard item={file.data} crop={ImageCroppingPresets.preview} noControls={true} /> */}
            </StyledGridItem>
        ))
    }

    const renderError = () => {
        if (!uploadErrorFiles || uploadErrorFiles.length <= 0) return (<div></div>)
        return uploadErrorFiles.map(file => (
            <StyledGridItem><MediaErrorPreview key={file.path} file={file} /></StyledGridItem>
        ))
    }

    const reuploadErrorFiles = (errorFiles) => {
        setUploadErrorFiles([])
        setFiles(errorFiles.map(file => {
            const f = new File([file], file.name, { type: file.type });
            return f;
            // return Object.assign(f, { progress: 0, })
        }
        )
        );

    }

    const getPercentCompleted = () => {
        const p = ((uploaded.length + uploadErrorFiles.length) / totalFiles) * 100;
        return p;
    }


    return (

        <Stack width="100%">


            {(uploaded.length + uploadErrorFiles.length) > 0 && (<StyledLinearProgressWithLabel value={getPercentCompleted()} />)}


            <StyledDropTarget
                thinking={uploading}
                clickable flex justify="center" align="center"
                {...getRootProps({ className: 'dropzone' })}
            >
                <input {...getInputProps()} />
                <StyledUploadText flex align="center" justify="center" direction="column">
                    <StyledIconButton className="icon"><IconUploadCloud /></StyledIconButton>
                    <StyledButton className="mobileButton" variant="contained">Upload</StyledButton>
                    <StyledB>Drop photos here or select files</StyledB>
                </StyledUploadText>
            </StyledDropTarget>

            <StyledGrid>
                {renderPreviews()}
            </StyledGrid>
            <Divider />
            {uploadErrorFiles && uploadErrorFiles.length > 0 && (
                <StyledGrid columns={2}>

                    {/* <SmartContainer>
                        <StyledP>The following assets were not uploaded.</StyledP>
                        <StyledButton variant='contained' onClick={() => reuploadErrorFiles(uploadErrorFiles)}>Try again</StyledButton>
                        <StyledButton variant='outlined' onClick={() => onFullUploadFinished()}>Skip</StyledButton>
                    </SmartContainer>
                    <StyledHr /> */}

                    {renderError()}
                </StyledGrid>
            )}

            <Divider />


            {uploaded && uploaded.length > 0 && (
                <SmartContainer>
                    <StyledHr />
                    <Divider />

                    <StyledGrid columns={8}>
                        {renderUploaded()}
                    </StyledGrid>
                </SmartContainer>
            )}


        </Stack>
    )
}

const MediaUploadPreview = ({ file, loading }) => {

    const type = (file.type.indexOf('image') > -1) ? 'image' : 'other';
    return (
        <Stack width="100%" flex direction="column" justify="flex-end">
            {type === 'image' && (
                <SmartContainer position="relative">
                    <SmartContainer thinking={loading}>
                        <StyledImg radius="1" shadow="one" src={file.preview} />
                    </SmartContainer>
                    {loading && file.progress !== 100 && (<SmartContainer absoluteCenter><StyledCircularProgressWithLabel value={file.progress} /></SmartContainer>)}
                    {loading && file.progress === 100 && (<SmartContainer absoluteCenter><StyledCircularProgress /></SmartContainer>)}
                </SmartContainer>
            )}
            {type !== 'image' && (
                <SmartContainer position="relative">
                    <SmartContainer thinking={loading} >
                        <StyledImagePlaceholder flex align="center" justify="center" minHeight="250px">{file.type}</StyledImagePlaceholder>
                    </SmartContainer>
                    {loading && file.progress !== 100 && (<SmartContainer absoluteCenter><StyledCircularProgressWithLabel value={file.progress} /></SmartContainer>)}
                    {loading && file.progress === 100 && (<SmartContainer absoluteCenter><StyledCircularProgress /></SmartContainer>)}
                </SmartContainer>
            )}
            <StyledEllipsis>{file.path}</StyledEllipsis>
        </Stack>
    )
}

export const MediaErrorPreview = ({ file, loading }) => {

    const type = (file.type.indexOf('image') > -1) ? 'image' : 'other';
    return (
        <Stack width="100%" flex direction="column" justify="flex-end">
            {type === 'image' && (
                <Surface>
                    <SmartContainer position="relative">
                        <HorizontalStack flex align="center" justify="flex-start">
                            <SmartContainer position="relative">
                                <SmartContainer absoluteCenter><IconError style={{ color: 'red' }} /></SmartContainer>
                                <StyledImg style={{ maxWidth: "100px" }} radius="1" shadow="one" src={file.preview} />
                            </SmartContainer>
                            <Stack>
                                <StyledEllipsis>{file.path}</StyledEllipsis>
                                {file?.errorMessage && (<StyledEllipsis>{file.errorMessage}</StyledEllipsis>)}
                            </Stack>
                        </HorizontalStack>

                        {loading && file.progress !== 100 && (<SmartContainer absoluteCenter><StyledCircularProgressWithLabel value={file.progress} /></SmartContainer>)}
                        {loading && file.progress === 100 && (<SmartContainer absoluteCenter><StyledCircularProgress /></SmartContainer>)}
                    </SmartContainer>
                </Surface>
            )}
            {type !== 'image' && (
                <SmartContainer position="relative">
                    <SmartContainer thinking={loading} >
                        <StyledImagePlaceholder flex align="center" justify="center" minHeight="250px">{file.type}</StyledImagePlaceholder>
                    </SmartContainer>
                    {loading && file.progress !== 100 && (<SmartContainer absoluteCenter><StyledCircularProgressWithLabel value={file.progress} /></SmartContainer>)}
                    {loading && file.progress === 100 && (<SmartContainer absoluteCenter><StyledCircularProgress /></SmartContainer>)}
                </SmartContainer>
            )}

        </Stack>
    )
}